import axios from "axios";
import { GURL } from "../services/global";

export class NoneODataServerSideDatasource {
  url: any;
  constructor(Url: any) {
    this.url = Url;
  }
  getRows(params: any) {
    // Make API call to fetch data from server
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
    axios
      .get(`${GURL}/${this.url}`)
      .then((response) => {
        console.log("response", response);

        if (response?.data?.data) {
          params.successCallback(response.data.data, -1);
        } else {
          params.successCallback([{}], 0);
        }

        // Return data to Ag Grid
      })
      .catch((error) => {
        console.error(error);
        // Return error to Ag Grid
        params.failCallback();
      });
  }
}
